import { render, staticRenderFns } from "./FormResetPassword.vue?vue&type=template&id=003d5eff&scoped=true"
import script from "./FormResetPassword.vue?vue&type=script&lang=js"
export * from "./FormResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d5eff",
  null
  
)

export default component.exports